import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { playSound } from '../../lib/effects';

const NAV_ITEMS = [
	{ key: 'new-pairs', label: 'Pairs', href: '/new-pairs' },
	{ key: 'trending', label: 'Trending', href: '/' },
	{ key: 'create', label: 'Create', href: '/new-token' },
	{ key: 'airdrop', label: 'Airdrop', href: '/airdrop', disabled: true },
	{ key: 'docs', label: 'Docs', href: 'https://ape-store.gitbook.io/ape.store-docs', external: true },
];

const NavIcon = ({ name, color }) => {
	const c = color;
	if (name === 'new-pairs') return (
		<svg width={22} height={22} viewBox="0 0 22 22" fill="none">
			<path d="M11 1c0 5-6 6.5-6 12a6 6 0 0 0 12 0c0-5.5-6-7-6-12Z" stroke={c} strokeWidth={1.8} strokeLinejoin="round" />
			<path d="M9 14a2.5 2.5 0 0 0 5 0c0-2-2.5-2.5-2.5-4.5" stroke={c} strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
	if (name === 'trending') return (
		<svg width={22} height={22} viewBox="0 0 22 22" fill="none">
			<path d="M3 17l5-5 3 3 8-8" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
			<path d="M14 7h5v5" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
	if (name === 'airdrop') return (
		<svg width={22} height={22} viewBox="0 0 22 22" fill="none">
			<path d="M3 9C3 4 19 4 19 9M3 9l5-1 3 1 3-1 5 1M3 9l7 7M19 9l-7 7M8 8l3 8M14 8l-3 8" stroke={c} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
			<rect x="9.5" y="16" width="3" height="3" stroke={c} strokeWidth={1.5} />
		</svg>
	);
	if (name === 'docs') return (
		<svg width={20} height={22} viewBox="0 0 18 22" fill="none">
			<rect x="1" y="1" width="16" height="20" rx="2" stroke={c} strokeWidth={1.8} />
			<path d="M5 6h8M5 10h8M5 14h5" stroke={c} strokeWidth={1.5} strokeLinecap="round" />
		</svg>
	);
	return null;
};

export const BottomNav = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const isActive = (item) => {
		if (item.key === 'trending') return pathname === '/';
		return pathname === item.href;
	};

	return (
		<nav className="pf-bottom-nav" style={{
			position: 'fixed', right: 0, bottom: 0, left: 0, zIndex: 60,
			display: 'none', alignItems: 'flex-end', justifyContent: 'space-around',
			borderTop: '3px solid #000', background: '#181818',
			padding: '6px 6px calc(6px + env(safe-area-inset-bottom))',
		}}>
			{NAV_ITEMS.map((item) => {
				const active = isActive(item);
				const center = item.key === 'create';
				const color = active ? 'var(--accent)' : '#b8b4a5';
				return (
					<button
						key={item.key}
						onClick={() => { if (item.disabled) return; playSound('click'); item.external ? window.open(item.href, '_blank', 'noopener,noreferrer') : navigate(item.href); }}
						style={{
							flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
							gap: '3px', cursor: item.disabled ? 'not-allowed' : 'pointer', border: 'none', background: 'transparent',
							padding: '7px 2px', borderRadius: '10px',
							opacity: item.disabled ? 0.4 : 1,
						}}
					>
						{center ? (
							<span style={{
								marginTop: '-20px', display: 'flex', height: '46px', width: '46px',
								alignItems: 'center', justifyContent: 'center',
								borderRadius: '50%', border: '3px solid #111',
								background: 'var(--accent)',
								boxShadow: '0 3px 0 rgba(0,0,0,0.4)',
							}}>
								<svg width={18} height={22} viewBox="0 0 18 22" fill="none">
									<path d="M10 1L3 12h5l-2 9 9-13h-6z" fill="#111" stroke="#111" strokeWidth={1} strokeLinejoin="round" />
								</svg>
							</span>
						) : (
							<span style={{ display: 'inline-flex' }}>
								<NavIcon name={item.key} color={color} />
							</span>
						)}
						<span style={{
							fontFamily: 'var(--font-sans)', fontSize: '10.5px', fontWeight: 600,
							letterSpacing: '0.3px', color,
						}}>
							{item.label}
						</span>
					</button>
				);
			})}
		</nav>
	);
};
